import {GitHubAvatar} from '@github-ui/github-avatar'
import {useHovercardAttributesForUser} from '@github-ui/hovercards/user'
import type {AssigneePickerAssignee} from '@github-ui/item-picker-assignee-tsq'
import {AvatarStack, Link} from '@primer/react'

import styles from './AssigneesMetadata.module.css'

export const AssigneesMetadata = ({assignees}: {assignees: AssigneePickerAssignee[]}) => {
  return (
    <AvatarStack className={styles.avatarStack}>
      {assignees.map(assignee => (
        <AssigneeLink key={assignee.id} assignee={assignee} />
      ))}
    </AvatarStack>
  )
}

function AssigneeLink({assignee}: {assignee: AssigneePickerAssignee}) {
  const hovercardAttrs = useHovercardAttributesForUser({login: assignee.login})

  return (
    <Link aria-label={`${assignee.login} is assigned`} href={`/${assignee.login}`} {...hovercardAttrs}>
      <GitHubAvatar alt={assignee.login} src={assignee.avatarUrl} className={styles.avatar} />
    </Link>
  )
}
